import React from "react";
import PropTypes from "prop-types";
import { Divider, Menu, MenuItem } from "@material-ui/core";

const InvoiceRowMenu = ({
  anchorEl,
  invoice,
  onClose,
  onViewPayment,
  onEditCustomer,
  onManageLots,
  onResend,
  onCancel,
}) => {
  const status = String(invoice?.status || "DRAFT").toUpperCase();
  const isCancelled = status === "CANCELLED";
  const paidAmount = Number(invoice?.paid_amount || 0);

  return (
    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onClose}>
      <MenuItem onClick={() => onViewPayment(invoice)}>View Payment</MenuItem>

      <MenuItem onClick={() => onEditCustomer(invoice)} disabled={isCancelled}>
        Edit Name/Email
      </MenuItem>

      <MenuItem onClick={() => onManageLots(invoice)} disabled={isCancelled}>
        Manage Lots
      </MenuItem>

      {status === "SENT" && (
        <MenuItem onClick={() => onResend(invoice)}>Resend Invoice</MenuItem>
      )}

      <Divider />

      {/*
        Destructive, so it sits below a divider and away from the rest --
        far enough that a misclick does not land on it.

        Disabled once money has been received. The backend refuses it too
        and says how much was paid; disabling here means the user finds
        out before clicking instead of after.
      */}
      <MenuItem
        onClick={() => onCancel(invoice)}
        disabled={isCancelled || paidAmount > 0}
        style={{ color: isCancelled || paidAmount > 0 ? undefined : "#c62828" }}
        title={
          isCancelled
            ? "This invoice is already cancelled"
            : paidAmount > 0
            ? "Cannot cancel: this invoice already has payments. Process a refund first."
            : "Cancel this invoice"
        }
      >
        Cancel Invoice
      </MenuItem>
    </Menu>
  );
};

InvoiceRowMenu.propTypes = {
  anchorEl: PropTypes.any,
  invoice: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  onViewPayment: PropTypes.func.isRequired,
  onEditCustomer: PropTypes.func.isRequired,
  onManageLots: PropTypes.func.isRequired,
  onResend: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default InvoiceRowMenu;
